import { makeStyles } from '@material-ui/core'
import { ChevronLeft as ChevronLeftIcon } from '@material-ui/icons'
import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'

import { Button, Container } from 'src/modules/ui'
import { useActionRunner } from 'src/modules/notification'

import { useSuppliers } from '../hooks'
import Product from './Product'

const useStyles = makeStyles(theme => ({
  backButton: {
    color: theme.palette.lightGreen.main,
    marginBottom: theme.spacing(1),
  },
  backLink: {
    textDecoration: 'inherit',
  },
}))

const ProductView = ({ linkPrefix, match, ...props }) => {
  const { id } = match.params

  const classes = useStyles()

  const { fetchProduct, product } = useSuppliers()
  const [doFetchProduct, fetching] = useActionRunner(fetchProduct, {
    initialFetchingState: true,
  })

  useEffect(() => {
    doFetchProduct(id)
  }, [])

  if (fetching || !product.id) {
    return null
  }

  return (
    <Container backLink>
      <Link
        className={classes.backLink}
        to={`${linkPrefix}/suppliers/${product.supplier.id}`}
      >
        <Button
          className={classes.backButton}
          size="large"
          startIcon={<ChevronLeftIcon />}
          variant="text"
        >
          Supplier
        </Button>
      </Link>
      <Product {...props} {...product} />
    </Container>
  )
}

ProductView.defaultProps = {
  linkPrefix: '',
}

export default ProductView
